import { notification, Button } from 'antd';
import { history } from '@umijs/max';
import React from 'react';

export const validateCredits = (creditsRemaining: number, type: string): boolean => {
  if (type === 'phone' && creditsRemaining < 10) {
    notification.error({
      message: `You have less than 10 credits remaining.`,
      description: 'To request phone number, you need minimum 10 credits. Please upgrade your plan or buy more credits.',
      placement: 'bottomRight',
      btn: React.createElement(
        Button,
        {
          style: { backgroundColor: 'black', color: 'white', borderColor: 'black' },
          onClick: () => history.push('/pricing')
        },
        'View Plans'
      )
    });
    return false;
  } else if ((type === 'person' || type === 'email') && creditsRemaining < 5) {
    notification.error({
      message: `You have less than 5 credits remaining.`,
      description: 'To reveal email, you need minimum 5 credits. Please upgrade your plan or buy more credits.',
      placement: 'bottomRight',
      btn: React.createElement(
        Button,
        {
          style: { backgroundColor: 'black', color: 'white', borderColor: 'black' },
          onClick: () => history.push('/pricing')
        },
        'View Plans'
      )
    });
    return false;
  } else if (creditsRemaining <= 0) {
    notification.error({
      message: `You have no credits remaining. Please upgrade your plan.`,
      description: 'You can upgrade your plan by clicking the button below.',
      placement: 'bottomRight',
      btn: React.createElement(
        Button,
        {
          style: { backgroundColor: 'black', color: 'white', borderColor: 'black' },
          onClick: () => history.push('/pricing')
        },
        'View Plans'
      )
    });
    return false;
  }
  return true;
};


